import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import React from "react";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "../../../styles/integrations.module.scss";
import { Context } from "pages/Integrations";

export class OlgaDrawer extends React.Component {
  state = {
    savingOptions: false,
    client_id: null,
    client_secret: null,
    api_key: null,
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async componentDidMount() {
    const selectedEnvironment =
      await EnvironmentStorage.getSelectedEnvironment();
    const credentialsResponse = await EnvironmentsAPI.getConfigurationsByAlias(
      selectedEnvironment,
      "external_credentials"
    );
    const olgaClientId = credentialsResponse?.olga?.CLIENT_ID;
    const olgaClientSecret = credentialsResponse?.olga?.CLIENT_SECRET;
    const olgaClientApiKey = credentialsResponse?.olga?.API_KEY;
    this.setState({
      client_id: olgaClientId,
      client_secret: olgaClientSecret,
      api_key: olgaClientApiKey,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;

      await this.setAsyncState({ savingOptions: true });

      const selectedEnvironment =
        await EnvironmentStorage.getSelectedEnvironment();
      const credentials = await EnvironmentsAPI.getConfigurationsByAlias(
        selectedEnvironment,
        "external_credentials"
      );

      if (!credentials.olga) {
        credentials.olga = {};
      }

      credentials.olga.CLIENT_ID = this.state.client_id;
      credentials.olga.CLIENT_SECRET = this.state.client_secret;
      credentials.olga.API_KEY = this.state.api_key;

      const response = await EnvironmentsAPI.putConfigurationsByAlias(
        selectedEnvironment,
        "external_credentials",
        credentials
      );
      await this.setAsyncState({ savingOptions: false });

      if (response.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível salvar as credenciais: ${
            response.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      await this.setAsyncState({ savingOptions: false });
    }
  }

  render() {
    const { visible, onClose } = this.props;
    const { client_id, client_secret, api_key, savingOptions } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Olga"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={this.onSave.bind(this)}
            loading={savingOptions}
            disabled={savingOptions}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        <div className={styles.scrollContainer}>
          <Input
            design="two"
            className="mb-20"
            floatLabel="CLIENT ID"
            value={client_id}
            onChange={(e) => this.setState({ client_id: e.target.value })}
          />
          <Input
            design="two"
            className="mb-20"
            floatLabel="CLIENT SECRET"
            value={client_secret}
            onChange={(e) => this.setState({ client_secret: e.target.value })}
          />
          <Input
            design="two"
            floatLabel="API KEY"
            value={api_key}
            onChange={(e) => this.setState({ api_key: e.target.value })}
          />
        </div>
      </Drawer>
    );
  }
}
